import { render, staticRenderFns } from "./XMarkIcon.vue?vue&type=template&id=b1774bea&"
import script from "./XMarkIcon.vue?vue&type=script&lang=js&"
export * from "./XMarkIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports